import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { ANALYTICS_DASHBOARDS_ACTION_TYPE } from '../actions';

const initialState = {
  companyDashboards: [],
  userDashboards: [],
  dashboardEmbedLink: null,
};

const dashboardsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case ANALYTICS_DASHBOARDS_ACTION_TYPE.GET_COMPANY_DASHBOARDS:
      case ANALYTICS_DASHBOARDS_ACTION_TYPE.SET_SELECTED_DASHBOARDS_BY_ROLE:
        draft.companyDashboards = payload;
        break;

      case ANALYTICS_DASHBOARDS_ACTION_TYPE.GET_USER_DASHBOARDS:
        draft.userDashboards = payload;
        break;

      case ANALYTICS_DASHBOARDS_ACTION_TYPE.GET_DASHBOARD_EMBED_LINK:
        draft.dashboardEmbedLink = payload;
        break;

      case RESET_STATE:
      case ANALYTICS_DASHBOARDS_ACTION_TYPE.RESET_DASHBOARDS_STATE:
        return initialState;

      default:
        break;
    }
  });

export default dashboardsReducer;
